import React from 'react';
import { Box, Typography } from '@mui/material';

const AdSpace = ({ 
  width = '100%', 
  height = '120px', 
  adContent = null,
  placeholder = false,
  sx = {} 
}) => {
  // Se não há conteúdo de anúncio e placeholder está desabilitado, não renderiza nada
  if (!adContent && !placeholder) {
    return null;
  }

  return (
    <Box
      sx={{
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed #ccc',
        backgroundColor: '#f9f9f9',
        marginBottom: 2,
        position: 'relative',
        overflow: 'hidden',
        ...sx
      }}
    >
      {adContent ? (
        <Box sx={{ width: '100%', height: '100%' }}>
          {adContent}
        </Box>
      ) : placeholder ? (
        <Box
          sx={{
            textAlign: 'center',
            color: '#999',
            padding: 2
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Espaço Publicitário
          </Typography>
          <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
            Em breve: anúncios relevantes para você
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default AdSpace;
